module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mu-menu-item', {
    ref: "menuItem",
    attrs: {
      "title": _vm.title
    },
    on: {
      "click": _vm.onClick
    }
  }, [(_vm.nestedItems.length > 0) ? _c('mu-menu-item', {
    attrs: {
      "title": _vm.selectAllTitle
    },
    on: {
      "click": _vm.onChooseAll
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.nestedItems), function(nested) {
    return _c('nest-menu-item', {
      ref: "nestedItems",
      refInFor: true,
      attrs: {
        "title": nested.title,
        "selectAllTitle": _vm.selectAllTitle,
        "itemData": nested,
        "nestedItemVisitor": _vm.nestedItemVisitor
      },
      on: {
        "choose-items": _vm.onChooseSubItems
      }
    })
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-13e7a154!./~/vue-loader/lib/selector.js?type=template&index=0!./src/foundation/ui/controls/nest-menu-item/component.vue
// module id = 952
// module chunks = 2